module.exports = __webpack_public_path__ + "img/fotografia_info.9aca79e1.jpg";